// extracted by mini-css-extract-plugin
export var container = "_hx-1";
export var editor = "_hx-2";
export var resizable = "_hx-3";
export var wrapper = "_hx-0";